import { render, staticRenderFns } from "./ConferenceOrganisation.vue?vue&type=template&id=b2f47998&scoped=true&"
import script from "./ConferenceOrganisation.vue?vue&type=script&lang=ts&"
export * from "./ConferenceOrganisation.vue?vue&type=script&lang=ts&"
import style0 from "./ConferenceOrganisation.vue?vue&type=style&index=0&id=b2f47998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f47998",
  null
  
)

export default component.exports